import React, {Component} from 'react';
import './App.css';
import './style/base.scss';

import {
  Switch,
  Redirect,
  Route,
  // BrowserRouter,
  HashRouter,
} from 'react-router-dom';
import 'antd-mobile/dist/antd-mobile.css';
// import $ from 'jquery';
// import classNames from 'classnames';
// import API from './config/api';
// import Const from './config/const';
// import Tool from './utils/tool';
// import Error from './utils/error';
// import {connect} from 'react-redux';
// import {refresh_admin} from './redux/models/admin';

import Detail from './pages/Detail/detail'; // 稿件详情
import Subject from './pages/Subject/subject'; // 专题
import NewSubject from './pages/NewSubject/newSubject' // 新型专题
import Homepage from './pages/Homepage/homepage'; // 东城号主页
import ColumnList from './pages/ColumnList/columnList'; // 栏目列表页,图文、视频、图说
import ColumnListAudio from './pages/ColumnListAudio/columnListAudio'; // 栏目列表页（音频）
import Fault from './pages/Fault/fault'; // 找不到页面
import Share from './pages/Share/share'; // 分享
import CivilizationList from './pages/CivilizationList/'; // 实践所和实践基地列表
import CivilizationListDetail from './pages/CivilizationListDetail/'; // 街道、实践基地详情
import CivilizationPraStationDetail from './pages/CivilizationPraStationDetail/'; // 实践站详情页
import CivilizationActivityDetail from './pages/CivilizationActivityDetail/'; // 基地活动和所站活动详情
import CivilizationTeamList from './pages/CivilizationTeamList/'; // 文明实践队伍列表
import CivilizationTeamDetail from './pages/CivilizationTeamDetail/'; // 志愿队伍详情
import Organization from './pages/Organization/' //机构职能一级列表（包含委办局和街道）
import Organization_list from './pages/Organization/Organization_list/' //机构职能一级列表（包含委办局和街道）
import Organization_detail from './pages/Organization/Organization_detail/' //机构职能详情（包含委办局和街道）
import MiddlePage from './pages/Detail/MiddlePage' // 呼起app中间页
import List from './pages/List/list' // 东城融媒
// @connect(
//   state => ({admin: state.admin}),
//   {refresh_admin}
// )
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentWillMount() {
    const script = document.createElement('script')
    script.src = 'https://s22.cnzz.com/z_stat.php?id=1275168103&web_id=1275168103'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  shouldComponentUpdate() {

  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" component={Fault}></Route>
          <Route path="/detail/:type/:uuid/:videoType?" component={Detail}></Route>
          <Route path='/middlePage/:url' component={MiddlePage}></Route>
          <Route path="/subject/:type/:uuid" component={Subject}></Route>
          <Route path="/newSubject/:uuid" component={NewSubject}></Route>
          <Route path="/homepage/:uuid" component={Homepage}></Route>
          <Route path="/columnList/:column_id" component={ColumnList}></Route>
          <Route path="/columnListAudio/:column_id" component={ColumnListAudio}></Route>
          <Route path="/share" component={Share}></Route>
          <Route path="/civilizationList" component={CivilizationList}></Route>
          <Route path="/civilizationListDetail" component={CivilizationListDetail}></Route>
          <Route path="/civilizationPraStationDetail" component={CivilizationPraStationDetail}></Route>
          <Route path="/civilizationActivityDetail" component={CivilizationActivityDetail}></Route>
          <Route path="/civilizationTeamDetail" component={CivilizationTeamDetail}></Route>
          <Route path="/organization" component={Organization} exact></Route>
          <Route path="/organization/organization_list" component={Organization_list}></Route>
          <Route path="/organization/organization_detail" component={Organization_detail}></Route>
          <Route path="/list" component={List}></Route>
          <Redirect path="*" to='/'></Redirect>
        </Switch>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js